/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  return async function onSubmit({ args }) {
    props.onSubmit && props.onSubmit(args.selected)
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
